function normalizePassword(value) {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value).trim()
}

function isPasswordLongEnough(value) {
  return normalizePassword(value).length >= 6
}

function validatePasswordPair(password, confirmPassword) {
  const normalizedPassword = normalizePassword(password)
  const normalizedConfirmPassword = normalizePassword(confirmPassword)
  const isEmpty = !normalizedPassword || !normalizedConfirmPassword
  const isTooShort = !isPasswordLongEnough(normalizedPassword) || !isPasswordLongEnough(normalizedConfirmPassword)
  const isMismatch = !isEmpty && normalizedPassword !== normalizedConfirmPassword

  return {
    password: normalizedPassword,
    confirmPassword: normalizedConfirmPassword,
    isEmpty,
    isTooShort,
    isMismatch,
    isValid: !isEmpty && !isTooShort && !isMismatch
  }
}

module.exports = {
  normalizePassword,
  isPasswordLongEnough,
  validatePasswordPair
}
